const navItem = {
  about: {
    text: 'phsucc_nav_about',
    href: '#about'
  },
  timeline: {
    text: 'phsucc_nav_timeline',
    href: '#timeline'
  },
  prizes: {
    text: 'phsucc_nav_prizes',
    href: '#prizes'
  },
  partner: {
    text: 'phsucc_nav_partners',
    href: '#partners'
  },
  faq: {
    text: 'phsucc_nav_faq',
    href: '#faq'
  },
  contact: {
    text: 'phsucc_nav_contact',
    href: '#contact'
  },
  careers: {
    text: 'phsucc_nav_careers',
    href: '/',
    target: '_blank'
  }
}

const sighUpLink = "https://techatshopee.formstack.com/forms/shopeeuccph2022"

function message () {
  return {
    application: {
      title: 'Shopee Philippines Ultimate Case Challenge 2022',
      desc: ' The Shopee Philippines Ultimate Case Challenge 2022 is a business case competition created to challenge the most inventive and innovative minds with real-world business problems. Designed with a unique multi-round format, you will collaborate as a team, take up the challenge and create effective solutions with your business acumen. Selected participants will get the chance to undergo an exclusive mentorship program with Shopee senior leaders, win attractive prizes and discover career opportunities at Shopee.',
      startDate: '22 August 2022',
      endDate: 'November 2022'
    },
    navbar: [
      navItem.about,
      navItem.timeline,
      navItem.prizes,
      navItem.faq,
      navItem.partner,
      navItem.contact,
      navItem.careers
    ],
    banner: {
      text: 'phsucc_banner_text',
      registerBtn: 'phsucc_banner_sign_up',
      sighUpLink,
      explain: 'phsucc_banner_explain',
      isPH: true,
      countDown: 'phsucc_countdown'
    },
    sighUpBtn: {
      sighUpLink,
      btnText: 'phsucc_banner_sign_up'
    },
    about: {
      title: 'phsucc_about_title',
      video: {
        playId: 'Shopee Ultimate Case Challenge 2022 | Shopee Philippines',
        videoKey: 'wJDM19RHgis',
        videoImg: require('@succ/public/images/about/video-bg.jpg')
      }
    },
    timeline: {
      title: 'phsucc_timeline_title',
      list: [{
        date: 'phsucc_timeline_date_1',
        title: 'phsucc_timeline_title_1',
        desc: ['phsucc_timeline_desc_1_01', 'phsucc_timeline_desc_1_02']
      }, {
        date: 'phsucc_timeline_date_2',
        title: 'phsucc_timeline_title_2',
        desc: ['phsucc_timeline_desc_2_01']
      }, {
        date: 'phsucc_timeline_date_3',
        title: 'phsucc_timeline_title_3',
        desc: ['phsucc_timeline_desc_3_01']
      }, {
        date: 'phsucc_timeline_date_4',
        title: 'phsucc_timeline_title_4',
        desc: ['phsucc_timeline_desc_4_01']
      }, {
        date: 'phsucc_timeline_date_5',
        title: 'phsucc_timeline_title_5',
        desc: ['phsucc_timeline_desc_5_01', 'phsucc_timeline_desc_5_02']
      }, {
        date: 'phsucc_timeline_date_6',
        title: 'phsucc_timeline_title_6',
        desc: ['phsucc_timeline_desc_6_01']
      }, {
        date: 'phsucc_timeline_date_7',
        title: 'phsucc_timeline_title_7',
        desc: ['phsucc_timeline_desc_7_01', 'phsucc_timeline_desc_7_02']
      }, {
        date: 'phsucc_timeline_date_8',
        title: 'phsucc_timeline_title_8',
        desc: ['phsucc_timeline_desc_8_01']
      }],
      explain: 'phsucc_timeline_explain'
    },
    prizes: {
      title: 'phsucc_title_prizes',
      desc: 'phsucc_prize_desc',
      // desc2: 'phsucc_prize_desc_2',
      list: [{
        title: 'phsucc_prize_title_1',
        money: 'phsucc_prize_money_1',
      }, {
        title: 'phsucc_prize_title_2',
        money: 'phsucc_prize_money_2',
      }, {
        title: 'phsucc_prize_title_3',
        money: 'phsucc_prize_money_3',
      }],
      full_width_list: [{
        image: require('@succ/public/images/prizes/team-ph.svg'),
        title: 'phsucc_prize_title_4',
        money: 'phsucc_prize_money_4',
      }],
      explain: 'phsucc_prize_explain'
    },
    faqs: {
      title: 'phsucc_title_faqs',
      sections: [{
        title: 'phsucc_faq_title_about',
        list: [{
          question: 'phsucc_faq_about_q1',
          desc: ['phsucc_faq_about_a1']
        }, {
          question: 'phsucc_faq_about_q2',
          desc: ['phsucc_faq_about_a2']
        }, {
          question: 'phsucc_faq_about_q3',
          desc: ['phsucc_faq_about_a3']
        }, {
          question: 'phsucc_faq_about_q4',
          desc: ['phsucc_faq_about_a4']
        }, {
          question: 'phsucc_faq_about_q5',
          desc: ['phsucc_faq_about_a5']
        }, {
          question: 'phsucc_faq_about_q6',
          desc: ['phsucc_faq_about_a6']
        }, {
          question: 'phsucc_faq_about_q7',
          desc: ['phsucc_faq_about_a7']
        }]
      }, {
        title: 'phsucc_faq_title_eligibility',
        list: [{
          question: 'phsucc_faq_eligibility_q1',
          desc: ['phsucc_faq_eligibility_a1']
        }, {
          question: 'phsucc_faq_eligibility_q2',
          desc: ['phsucc_faq_eligibility_a2']
        }, {
          question: 'phsucc_faq_eligibility_q3',
          desc: ['phsucc_faq_eligibility_a3']
        }, {
          question: 'phsucc_faq_eligibility_q4',
          desc: ['phsucc_faq_eligibility_a4']
        }, {
          question: 'phsucc_faq_eligibility_q5',
          desc: ['phsucc_faq_eligibility_a5']
        }, {
          question: 'phsucc_faq_eligibility_q6',
          desc: ['phsucc_faq_eligibility_a6']
        }, {
          question: 'phsucc_faq_eligibility_q7',
          desc: ['phsucc_faq_eligibility_a7']
        }, {
          question: 'phsucc_faq_eligibility_q8',
          desc: ['phsucc_faq_eligibility_a8']
        }, {
          question: 'phsucc_faq_eligibility_q9',
          desc: ['phsucc_faq_eligibility_a9']
        }, {
          question: 'phsucc_faq_eligibility_q10',
          desc: ['phsucc_faq_eligibility_a10']
        }]
      }, {
        title: 'phsucc_faq_title_registration',
        list: [{
          question: 'phsucc_faq_registration_q1',
          desc: ['phsucc_faq_registration_a1']
        }, {
          question: 'phsucc_faq_registration_q2',
          desc: ['phsucc_faq_registration_a2']
        }, {
          question: 'phsucc_faq_registration_q3',
          desc: ['phsucc_faq_registration_a3']
        }, {
          question: 'phsucc_faq_registration_q4',
          desc: ['phsucc_faq_registration_a4']
        }]
      }, {
        title: 'phsucc_faq_title_mentorship',
        list: [{
          question: 'phsucc_faq_mentorship_q1',
          desc: ['phsucc_faq_mentorship_a1']
        }, {
          question: 'phsucc_faq_mentorship_q2',
          desc: ['phsucc_faq_mentorship_a2']
        }, {
          question: 'phsucc_faq_mentorship_q3',
          desc: ['phsucc_faq_mentorship_a3']
        }]
      }, {
        title: 'phsucc_faq_title_inquiries',
        list: [{
          question: 'phsucc_faq_inquiries_q1',
          desc: ['phsucc_faq_inquiries_a1']
        }]
      }]
    },
    contact: {
      // title: 'succ_title_contact',
      desc: [
        'phsucc_contact_desc_1'
       ],
      btn: 'phsucc_contact_btn',
      btnLink: 'mailto:campus.ph@shopee.com'
    },
    footer: {
      logoStatic: true,
      follow: 'phsucc_follow_us',
      social: [{
        href: 'https://www.facebook.com/shopeecareers.ph',
        name: 'facebook',
        icon: require('@/assets/images/icon-facebook.svg')
      }, {
        href: 'https://www.instagram.com/lifeatshopee/',
        name: 'instagram',
        icon: require('@/assets/images/icon-instagram.svg')
      }, {
        href: 'https://www.linkedin.com/company/shopee/',
        name: 'linkedin',
        icon: require('@/assets/images/icon-linkedin.svg')
      }],
      links: [[
        navItem.about,
        navItem.timeline,
        navItem.prizes,
      ], [
        navItem.faq,
        navItem.partner,
        navItem.contact,
      ], [
        navItem.careers
      ]],
      tc: 'pdf/ph/succ-terms-and-conditions.pdf',
      privacyPolicy: 'https://shopee.ph/docs/3591',
      copyright: 'Copyright © Shopee Limited. Trademarks belong to their respective owners. All rights reserved.'
    }
  }
}

export default message;
